<script setup>

import {onUpdated, ref, watch} from "vue";
import {useLanguageStore} from "@/pinia";
import TransferHistoryTab from "@/components/modal/video/TransferHistoryTab.vue";

const languageStore = useLanguageStore();
const props = defineProps({
  isVideoDetail : {default : false},
  video : {default : {}}
})
const emits = defineEmits(['set_isVideoDetail'])

const activeTab = ref('basic');
const videoId = ref("");
const folderId = ref("");
const videoTitle = ref("");
const videoDescription = ref("");
const videoName = ref("");
const videoSize = ref("");
const videoTime = ref("");
const regDt = ref("");
const regUser = ref("");
const modDt = ref("");
const modUser = ref("");
const privateStatus = ref("");
const meetingId = ref("");
const snsVideo = ref({});

const close = ()=>{
  activeTab.value = 'basic';
  videoId.value = "";
  folderId.value = "";
  videoTitle.value = "";
  videoDescription.value = "";
  videoName.value = "";
  videoSize.value = "";
  videoTime.value = "";
  regDt.value = "";
  regUser.value = "";
  modDt.value = "";
  modUser.value = "";
  privateStatus.value = "";
  meetingId.value = "";
  snsVideo.value = {};
  emits('set_isVideoDetail', false)
}

onUpdated(()=>{
  videoId.value = props.video.id;
  folderId.value = props.video.folderId;
  videoTitle.value = props.video.videoTitle;
  videoDescription.value = props.video.videoDescription;
  videoName.value = props.video.videoName;
  videoSize.value = props.video.videoSize;
  videoTime.value = props.video.videoTime;
  regDt.value = props.video.regDt;
  regUser.value = props.video.regUser;
  modDt.value = props.video.modDt;
  modUser.value = props.video.modUser;
  privateStatus.value = props.video.privateStatus;
  meetingId.value = props.video.meetingId;
  snsVideo.value = props.video.snsVideo;
})

watch(() => props.isVideoDetail, (newVal) => {
  if (newVal) {
    activeTab.value = 'basic';
  }
})
</script>

<template>
  <v-dialog
      :model-value="isVideoDetail"
      @update:modelValue="close"
      width="auto"
  >
    <v-card :title="languageStore.get('videoDetail')" width="700">
      <v-tabs v-model="activeTab" color="primary" class="detail-tabs">
        <v-tab value="basic">{{ languageStore.get('basicInfo') }}</v-tab>
        <v-tab value="transfer">{{ languageStore.get('transferHistory') }}</v-tab>
      </v-tabs>

      <v-card-text>
        <v-window v-model="activeTab">
          <!-- 기본 정보 탭 -->
          <v-window-item value="basic">
            <v-text-field
                v-model="videoTitle"
                :label="languageStore.get('videoTitle')"
                variant="outlined"
                density="compact"
                hide-details="auto"
                readonly
                class="mb-4"
            ></v-text-field>

            <v-textarea
                v-model="videoDescription"
                :label="languageStore.get('description')"
                variant="outlined"
                density="compact"
                rows="3"
                hide-details="auto"
                readonly
                class="mb-4"
            ></v-textarea>

            <v-text-field
                v-model="videoName"
                :label="languageStore.get('fileName')"
                variant="outlined"
                density="compact"
                hide-details="auto"
                readonly
                class="mb-4"
            ></v-text-field>

            <v-row>
              <v-col cols="6">
                <v-text-field
                    v-model="videoSize"
                    :label="languageStore.get('fileSize')"
                    variant="outlined"
                    density="compact"
                    hide-details="auto"
                    readonly
                ></v-text-field>
              </v-col>
              <v-col cols="6">
                <v-text-field
                    v-model="videoTime"
                    :label="languageStore.get('playTime')"
                    variant="outlined"
                    density="compact"
                    hide-details="auto"
                    readonly
                ></v-text-field>
              </v-col>
            </v-row>

            <v-row class="mt-4">
              <v-col cols="6">
                <v-text-field
                    v-model="regDt"
                    :label="languageStore.get('createdDate')"
                    variant="outlined"
                    density="compact"
                    hide-details="auto"
                    readonly
                ></v-text-field>
              </v-col>
              <v-col cols="6">
                <v-text-field
                    v-model="regUser"
                    :label="languageStore.get('createdBy')"
                    variant="outlined"
                    density="compact"
                    hide-details="auto"
                    readonly
                ></v-text-field>
              </v-col>
            </v-row>

            <v-row v-if="modDt != null || modUser != null" class="mt-4">
              <v-col cols="6">
                <v-text-field
                    v-model="modDt"
                    :label="languageStore.get('modifiedDate')"
                    variant="outlined"
                    density="compact"
                    hide-details="auto"
                    readonly
                ></v-text-field>
              </v-col>
              <v-col cols="6">
                <v-text-field
                    v-model="modUser"
                    :label="languageStore.get('modifiedBy')"
                    variant="outlined"
                    density="compact"
                    hide-details="auto"
                    readonly
                ></v-text-field>
              </v-col>
            </v-row>

            <template v-for="sns in snsVideo" :key="sns.videoId">
              <v-row class="mt-4">
                <v-col cols="4">
                  <v-text-field
                      :model-value="sns.snsType"
                      :label="languageStore.get('snsType')"
                      variant="outlined"
                      density="compact"
                      hide-details="auto"
                      readonly
                  ></v-text-field>
                </v-col>
                <v-col cols="8">
                  <v-text-field
                      :model-value="sns.snsVideoId"
                      :label="languageStore.get('snsVideoId')"
                      variant="outlined"
                      density="compact"
                      hide-details="auto"
                      readonly
                  ></v-text-field>
                </v-col>
              </v-row>
            </template>
          </v-window-item>

          <!-- 전송 이력 탭 -->
          <v-window-item value="transfer">
            <TransferHistoryTab :video-id="videoId" />
          </v-window-item>
        </v-window>
      </v-card-text>

      <v-card-actions class="modal-actions">
        <v-spacer></v-spacer>
        <v-btn variant="outlined" @click="close">{{ languageStore.get('close') }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<style scoped>
/* 모달 헤더 스타일 */
:deep(.v-card-item) {
  background-color: #1A3A5C !important;
  padding: 0 !important;
}

:deep(.v-card-title) {
  background-color: #1A3A5C !important;
  color: #FFFFFF !important;
  padding: 16px 24px !important;
  font-weight: 600 !important;
  font-size: 18px !important;
}

/* 탭 스타일 */
.detail-tabs {
  border-bottom: 1px solid #DEE2E6;
}

:deep(.v-tabs) {
  background-color: #f5f5f5;
}

/* 모달 바디 - Vuetify 기본 padding 제거 */
:deep(.v-card-text) {
  padding: 24px !important;
}

/* 모달 액션 - Vuetify 기본 padding 제거 */
:deep(.v-card-actions.modal-actions) {
  padding: 16px 24px !important;
  border-top: 1px solid #DEE2E6;
  gap: 8px;
}

/* v-card-text 내 입력 필드 간격 */
.v-card-text :deep(.v-input) {
  margin-bottom: 16px;
}

/* v-row 내부의 v-input은 margin 제외 */
.v-card-text :deep(.v-row .v-input) {
  margin-bottom: 0;
}

.v-card-text :deep(.v-row) {
  margin-top: 0;
  margin-bottom: 16px;
}

.v-card-text :deep(.v-col) {
  padding-top: 0;
  padding-bottom: 0;
}

.v-card-text :deep(.v-row:last-child) {
  margin-bottom: 0;
}
</style>
